import React, {useState} from 'react';
import DashboardLayout from '@/shared/layout/DashboardLayout';
import PageHeader from '@/shared/layout/PageHeader';
import {Package} from 'lucide-react';

const RegisterKit: React.FC = () => {
    const [kitCode, setKitCode] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setIsSubmitting(true);
        // Kit registration logic would go here
        setTimeout(() => setIsSubmitting(false), 1000);
    };

    return (
        <DashboardLayout>
            <PageHeader
                title="Register a Kit"
                subtitle="Enter your kit activation code to get started with your test"
            />

            <div className="max-w-md mx-auto">
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8">
                    <div className="text-center mb-6">
                        <Package className="h-16 w-16 text-mld-primary mx-auto mb-4" />
                        <h3 className="text-lg font-semibold text-mld-text-primary mb-2">Activate Your Test Kit</h3>
                        <p className="text-gray-600 text-sm">
                            Enter the activation code found on your test kit package
                        </p>
                    </div>

                    <form onSubmit={handleSubmit} className="space-y-6">
                        <div>
                            <label htmlFor="kitCode" className="block text-sm font-medium text-mld-text-primary mb-2">
                                Kit Activation Code
                            </label>
                            <input
                                type="text"
                                id="kitCode"
                                value={kitCode}
                                onChange={(e) => setKitCode(e.target.value.toUpperCase())}
                                placeholder="Enter activation code"
                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-mld-primary focus:border-transparent text-center font-mono text-lg"
                                required
                            />
                            <p className="text-xs text-gray-500 mt-2">Format: ABC-123-DEF or similar</p>
                        </div>

                        <button
                            type="submit"
                            disabled={!kitCode.trim() || isSubmitting}
                            className="w-full py-3 px-4 bg-mld-primary text-white rounded-lg font-medium hover:bg-mld-primary/90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
                            {isSubmitting ? 'Activating...' : 'Activate Kit'}
                        </button>
                    </form>

                    <div className="mt-6 text-center">
                        <p className="text-sm text-gray-600">
                            Need help finding your activation code?{' '}
                            <a href="/support" className="text-mld-primary hover:text-mld-primary/80">
                                Contact support
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </DashboardLayout>
    );
};

export default RegisterKit;
